import { render, staticRenderFns } from "./InfoItemListByDate.vue?vue&type=template&id=b6d09874&"
import script from "./InfoItemListByDate.vue?vue&type=script&lang=js&"
export * from "./InfoItemListByDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports